export default "__VITE_ASSET__IJFEZ__d__"